<template>
  <v-radio-group v-model="inputValue" :mandatory="false" row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-radio
          v-bind:label="$t('info_card.in_thai')"
          value="inThai"
        ></v-radio>
      </v-col>
      <v-col cols="12" sm="4">
        <v-radio
          v-bind:label="$t('info_card.foreign_country')"
          value="foreignCountry"
        ></v-radio>
      </v-col>
      <v-col cols="12" sm="4" v-if="shown === true">
        <v-radio v-bind:label="$t('info_card.other')" value="other"></v-radio>
      </v-col>
    </v-row>
  </v-radio-group>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
export default {
  name: "ThaiOrForeignCountry",
  props: {
    value: String,
    shown: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    objectTranslator,
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
